@if (errorService.errorSignal(); as error) {
    <div>
        <strong>{{ error.translationKey ? (error.translationKey! | translate) : error }}</strong>
        <button matButton (click)="errorService.cleanError()">x</button>
    </div>
}
